import { FeatureFlags } from '../constants/FeatureFlags';
import { usePublicFeatureFlags } from './usePublicFeatureFlags';
export function useIsStarterTierCopyRenameEnabled() {
  const {
    featureFlags
  } = usePublicFeatureFlags();
  return featureFlags.includes(FeatureFlags.PRICING_PAGE_STARTER_TIER_RENAME);
}